import { render, staticRenderFns } from "./sub-menu.vue?vue&type=template&id=2f1f2a96&scoped=true&"
import script from "./sub-menu.vue?vue&type=script&lang=js&"
export * from "./sub-menu.vue?vue&type=script&lang=js&"
import style0 from "./sub-menu.vue?vue&type=style&index=0&id=2f1f2a96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1f2a96",
  null
  
)

export default component.exports